export const MAX_CLOCK_INCREMENT = 1000 * 60;
